module.exports = __webpack_public_path__ + "img/125.730c2d48.jpg";